/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllGames,
  ErrorResponse,
} from '../models/index';
import {
    AllGamesFromJSON,
    AllGamesToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface GetAllGamesRequest {
    customerId: string;
    includeInactive?: boolean;
    includeUpcoming?: boolean;
    includeHistorical?: boolean;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class AllGamesApi extends runtime.BaseAPI {

    /**
     * Get all games (draw, instant, fast play, rapid)
     */
    async getAllGamesRaw(requestParameters: GetAllGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllGames>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getAllGames().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeInactive'] != null) {
            queryParameters['includeInactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['includeUpcoming'] != null) {
            queryParameters['includeUpcoming'] = requestParameters['includeUpcoming'];
        }

        if (requestParameters['includeHistorical'] != null) {
            queryParameters['includeHistorical'] = requestParameters['includeHistorical'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:games"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/all-games`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllGamesFromJSON(jsonValue));
    }

    /**
     * Get all games (draw, instant, fast play, rapid)
     */
    async getAllGames(requestParameters: GetAllGamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllGames> {
        const response = await this.getAllGamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
